import { ENV } from '@/configs/env';

let BASE_URL = 'https://dsim568-api.intra.xiaojukeji.com';

if (process.env.BUILD_ENV === ENV.DEV) {
    BASE_URL = 'https://dsim568-api.intra.xiaojukeji.com';
}

if (process.env.BUILD_ENV === ENV.ONLINE) {
    BASE_URL = 'https://market-growth-api.didifinance.com';
}

if (process.env.BUILD_ENV === ENV.PRE) {
    BASE_URL = 'https://market-pre-growth-api.intra.didifinance.com';
}

if (process.env.BUILD_ENV === ENV.SIM) {
    BASE_URL = `${window.location.origin.replace('page', 'api')}`;
}

export const API_JOIN_ACTIVITY = `${BASE_URL}/marketing-portal/landing-page/v2/activity/recall`;

export const API_GET_ACTIVITY = `${BASE_URL}/marketing-portal/landing-page/v2/query/config`;
